import type { DiscountAppliedTo } from '../enums/DiscountAppliedTo'
import type { DiscountType } from '../enums/DiscountType'
import type { CampaignBranchEntity } from './CampaignBranchEntity'

export class CampaignStepEntity {
  index?: number
  type?: DiscountType
  value?: number
  maxDiscountAllowed?: number
  appliedTo?: DiscountAppliedTo
  minCartAmount?: number | null
  branches?: Array<CampaignBranchEntity> | null
  defaultServiceRatio?: number
  defaultBranchRatio?: number
  limitedDefaultBranchShareAmount?: number | null
  bonusPoints?: number | null
  bonusMultiplier?: number | null
  isActive?: boolean
}
